import React from 'react';
import PropTypes from 'prop-types';
// import Toggle from 'react-toggle';
import 'react-toggle/style.css';
import Input from '../../../components/Input';
import {Button, buttonTypes} from '../../../components/Button';

const Profile = (props) => {

  const {
    successUpdated,
    vendorType,
    name,
    lastName,
    email,
    phone,
    // sendEmailNotifications,
    error,
    handleChange,
    showChangePassword,
    showChangeEmail,
    showDeleteAccount,
    editProfile,
    companyName
  } = props;


  // const onChangeToggle = () => {
  //   handleChange({target: {name: 'sendEmailNotifications', value: !sendEmailNotifications}})
  // };

  return (
    <div className="profile">
      <h2 className="profile__title">{successUpdated ? <p className="successes">Profile updated successfully</p> : 'Settings'}</h2>
      <div className="profile__group-wrap">
        <div className="profile__group profile__group-set">
          <Input
            className="profile__block"
            type="text"
            label="Name"
            placeholder="Name"
            value={name}
            name="name"
            error={error.name}
            onChange={(e) => handleChange(e)}
          />
          <Input
            className="profile__block"
            type="text"
            label="Last Name"
            placeholder="Last Name"
            value={lastName || ''}
            name="lastName"
            error={error.lastName}
            onChange={(e) => handleChange(e)}
          />
          {vendorType && vendorType === 'tour' ?
            <Input
              className="profile__block"
              type="text"
              label="Company name"
              placeholder="Company name"
              value={companyName || ''}
              name="companyName"
              error={error.companyName || ''}
              onChange={(e) => handleChange(e)}
            /> : null
          }
          <Input
            className="profile__block"
            type="text"
            label="Phone"
            placeholder="Phone"
            value={phone}
            name="phone"
            error={error.phone || ''}
            onChange={(e) => handleChange(e)}
          />
          <div className="profile__block">
            <Input
              type="text"
              label="Email"
              placeholder="Email"
              value={email}
              name="email"
              error={error.email}
              onChange={() => {
              }}
            />
            <Button
              type={buttonTypes.LINK}
              name="Change"
              onClick={showChangeEmail}
            />
          </div>
          <div className="profile__block">
            <Input
              type="password"
              label="Password"
              placeholder="Password"
              value="******"
              name="password"
              error={error.password}
              onChange={() => {
              }}
            />
            <Button
              type={buttonTypes.LINK}
              name="Change"
              onClick={showChangePassword}
            />
          </div>
        </div>
      </div>
      {/* <div className="profile__group">
        <div className="profile__block">
          <p className="profile__block__label input-block__label">Email notifications</p>
          <div className="toggle-block">
            <p className="toggle-block__label">Send me confirmation email or something else...</p>
            <Toggle
              defaultChecked={sendEmailNotifications}
              icons={false}
              onChange={onChangeToggle}
            />
          </div>
        </div>
      </div> */}
      <div className="profile__delete">
        <p>Also you can delete your account
          <Button
            type={buttonTypes.LINK}
            name="here"
            onClick={showDeleteAccount}
          />
        </p>
      </div>
      <div className="profile__buttons">
        <Button
          type={buttonTypes.AUTHENTICATION}
          name="Save"
          onClick={editProfile}
        />
      </div>
    </div>
  )
};

Profile.propTypes = {
  vendorType: PropTypes.string,
  successUpdated: PropTypes.bool,
  name: PropTypes.string,
  lastName: PropTypes.string,
  email: PropTypes.string,
  phone: PropTypes.string,
  companyName: PropTypes.string,
  // sendEmailNotifications: PropTypes.bool,
  error: PropTypes.object,
  handleChange: PropTypes.func,
  showChangeEmail: PropTypes.func,
  showChangePassword: PropTypes.func,
  editProfile: PropTypes.func,
  showDeleteAccount: PropTypes.func,
};

export default Profile


// WEBPACK FOOTER //
// ./src/app/containers/Profile/components/MainInfo.js